// frontend/src/components/auth/RequireReportsAccess.tsx
// Guard de ruta del módulo de reports: solo pasa quien tenga acceso a la empresa
// avp (App Role Empresa.AVP o Empresa.All). Cierra la entrada por URL directa,
// además de ocultar el enlace del menú.
//
// Mismo patrón que RequireEmpresaAll y con el mismo query ['auth-me']: no
// redirige mientras carga, para no expulsar a un usuario legítimo en un refresh
// directo sobre la ruta.
//
// El cierre real está en el backend (get_reports_empresas): esto es solo la capa
// de navegación.
import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet } from 'react-router-dom'
import { authApi } from '@/services/api'

export function RequireReportsAccess() {
  const { data, isLoading } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  })
  if (isLoading) return null
  if (!data?.empresas?.includes('avp')) return <Navigate to="/home" replace />
  return <Outlet />
}
